/**
 * Runtime app configuration.
 *
 * Values are injected by Django into window.APP_CONFIG at request time, so
 * Kubernetes can change them via ConfigMap without requiring a new build.
 *
 * Build-time constants (COMMIT_HASH, RELEASE_VERSION, NODE_ENV) are still
 * handled by webpack DefinePlugin and accessed via process.env directly.
 */
const appConfig = (typeof window !== 'undefined' && window.APP_CONFIG) || {};

export const DEPLOYMENT_TIER = appConfig.DEPLOYMENT_TIER || '';
export const RECAPTCHA_SKIP = appConfig.RECAPTCHA_SKIP === 'True';
